import curry from "../../lib/core/functional/curry";
import all from "../../lib/core/functional/all";

const requireSectionId = (context) =>
    ![null, undefined].includes(context.sectionId) && !isNaN(Number(context.sectionId));
const requirePermission = curry((permission, context) => context.permissions[permission] || false);

const menuItems = (context) => [
    context,
    [
        {
            name: "edit",
            className: "edit",
            title: "Edit",
            icon: "edit",
            requirement: requirePermission("edit_post"),
        },
        {
            name: "freeze",
            className: "freeze",
            title: "Freeze Post: keep this story in this spot on the page",
            icon: "ac_unit",
            requirement: all(requireSectionId, requirePermission("reorder_frontpage")),
        },
        {
            name: "socialScheduling",
            className: "editor-tab",
            title: "Social Scheduling",
            icon: "share",
            requirement: requirePermission("edit_post"),
            dataAttrs: {
                "tab-id": "social_scheduling",
            },
        },
        {
            name: "socialCopy",
            className: "editor-tab",
            title: "Social Copy",
            icon: null,
            iconClass: "icons--social",
            requirement: requirePermission("edit_post"),
            dataAttrs: {
                "tab-id": "stats",
            },
        },
        {
            name: "stats",
            className: "editor-tab",
            title: "Stats",
            icon: "trending_up",
            requirement: requirePermission("edit_post"),
            dataAttrs: {
                "tab-id": "social_scheduling",
            },
        },
        {
            name: "remove",
            className: "remove",
            title: "Remove",
            icon: "delete",
            requirement: all(requireSectionId, requirePermission("delete_post")),
        },
    ],
];

export default menuItems;
